export function parseQueryString (queryString) {
  const qs = queryString || window.location.search
  if (qs) {
    const params = qs.slice(1)
    const paramObj = {}
    params.split('&').forEach(param => {
      paramObj[param.split('=')[0]] = param.split('=')[1]
    })

    return paramObj
  }

  return null
}

/**
 * A function to make query string from object
 * @param params { Object }
 */
export function makeQueryString (params) {
  return '?' + Object.entries(params).map(query => {
    return query.join('=')
  }).join('&')
}
